export const loadingConstant = {
    OPEN: 'LOADING_OPEN',
    CLOSE: 'LOADING_CLOSE'
};
